export default __webpack_public_path__ + "static/electronic_engineer-59120110d317b87d4e62e01f04c44a91.svg";